export default __webpack_public_path__ + "static/media/37_polot.9e7eb0d9.JPG";